import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import TvIcon from '@mui/icons-material/Tv';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export default function BottomNav({ activeTab, onChange }) {
  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100 }} elevation={8}>
      <BottomNavigation value={activeTab} onChange={(_, v) => onChange(v)} showLabels>
        <BottomNavigationAction label="Tracker"    value={0} icon={<HomeIcon />} />
        <BottomNavigationAction label="Watch List" value={1} icon={<TvIcon />} />
        <BottomNavigationAction label="Suggest"    value={2} icon={<AutoAwesomeIcon />} />
      </BottomNavigation>
    </Paper>
  );
}
